export const FIELD = {
  INPUT: 'InputField',
  CHECKBOX: 'CheckboxField',
  NUMBER_WITH_TEMPLATE: 'NumberWithTemplateField',
  PASSWORD_WITH_METER: 'PasswordWithMeterField',
};

export const ELEMENT = {
  INPUT: 'InputElement',
};

export const ERROR = {
  NESTED_INPUT: 'Option "props" cannot have nested input options!',
  MISSING_OPTION: 'Missing required option',
};

export default {
  FIELD,
  ELEMENT,
  ERROR,
};
